// @flow
import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router';
import styled, { withTheme } from 'styled-components';
import CampaignDashboardListing from 'common/modules/campaign/domain/CampaignDashboardListing';
import { getToken } from 'statsradio/modules/authentication/session/selectors/sessionSelectors';
import Radio from 'common/domain/radio';
import Paging from 'statsradio/modules/pagination/domain/paging';
import CampaignDashboardQuery from 'statsradio/modules/campaigns/domain/CampaignDashboardQuery';
import DashboardCampaignApi from 'statsradio/modules/campaigns/services/DashboardCampaignApi';
import withSplashLoader from 'common/components/withSplashLoader';
import { Card, CardHeader, CardTitle } from '../../../../themes/v2/Stylesheet';
import SwitchPageFooter from '../SwitchPageFooter';
import LinkedCampaignsTable from './LinkedCampaignsTable';
import { SalesMember } from '../../../salesMembers/domain/SalesMember';

export const NO_CAMPAIGNS_MESSAGE_ID = 'NO_CAMPAIGNS_MESSAGE_ID';
export const LOADING_SPINNER_ID = 'LOADING_SPINNER_ID';
export const LINKED_CAMPAIGNS_TABLE_ID = 'LINKED_CAMPAIGNS_TABLE_ID';

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledTitle = styled(CardTitle)`
  flex: 1;
`;

const NoCampaignMessage = styled.div`
  padding: ${({ theme }) => theme.V2.metrics.margin.small}px ${({ theme }) => theme.V2.metrics.margin.normal}px;
`;

const StyledSwitchPageFooter = styled(SwitchPageFooter)`
  padding: ${({ theme }) => theme.V2.metrics.margin.small}px;
`;

const CardContent = withSplashLoader('isFetching', 'small')(styled.div``);


interface Props {
  selectedSalesMember?: SalesMember;

  t: any;
  theme: any;
  history: any;
  className?: any;
  token: string;
  radio: Radio;
}

type State = {
  campaigns: CampaignDashboardListing[];
  isFetching: boolean;
  error: boolean;
  paging: Paging;
  currentPage: number;
}

const DEFAULT_STATE = {
  campaigns: [],
  isFetching: false,
  error: false,
  paging: new Paging({ currentPage: 1, numberOfPages: 1 }),
  currentPage: 1,
};

export class LinkedCampaignsCard extends React.Component<Props, State> {
  state = DEFAULT_STATE;

  componentDidMount() {
    this.fetchRecentlyLinkedCampaigns();
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const radioChanged = !this.props.radio.isSame(prevProps.radio);
    const salesmanFilterChanged = this.props.selectedSalesMember !== prevProps.selectedSalesMember;
    const pageChanged = this.state.currentPage !== prevState.currentPage;
    const isOnFirstPage = this.state.currentPage === 1;

    if ((radioChanged || salesmanFilterChanged) && !isOnFirstPage) {
      this.onCurrentPageChange(1);
    } else if ((radioChanged || salesmanFilterChanged) && isOnFirstPage) {
      this.fetchRecentlyLinkedCampaigns();
    } else if (pageChanged) {
      this.fetchRecentlyLinkedCampaigns();
    }
  }

  async fetchRecentlyLinkedCampaigns() {
    const { token, radio } = this.props;
    this.setState({ isFetching: true });

    try {
      const salesmanReference = this.props.selectedSalesMember ? this.props.selectedSalesMember.reference : undefined;
      const query = new CampaignDashboardQuery({ page: this.state.currentPage, salesmanReference });
      const results = await DashboardCampaignApi.listRecentlyLinkedCampaigns(token, radio.callSign, query);
      const paging = results.getPaging();
      this.setState({ campaigns: results.items, isFetching: false, error: false, paging });
    } catch (error) {
      this.setState({ isFetching: false, error: true });
    }
  }

  onCurrentPageChange = (page: number) => {
    this.setState({ currentPage: page });
  };

  render() {
    const { t, className } = this.props;
    const { isFetching, campaigns, paging } = this.state;
    const hasCampaigns = campaigns.length > 0;

    return (
      <StyledCard className={className}>
        <CardHeader>
          <StyledTitle>
            {t('recentlyLinked')}
          </StyledTitle>
        </CardHeader>
        <CardContent isFetching={isFetching}>
          {!hasCampaigns &&
          <NoCampaignMessage id={NO_CAMPAIGNS_MESSAGE_ID}>
            {t('noRecentlyLinkedCampaign')}
          </NoCampaignMessage>
          }
          {hasCampaigns &&
          <LinkedCampaignsTable
            id={LINKED_CAMPAIGNS_TABLE_ID} campaigns={campaigns}
          />
          }
        </CardContent>
        <StyledSwitchPageFooter paging={paging} onPageChange={this.onCurrentPageChange} />
      </StyledCard>
    );
  }
}

function mapStateToProps(state) {
  return {
    token: getToken(state),
    radio: state.session.radio,
  };
}

export default withTheme(translate('salesDashboard')(connect(mapStateToProps)(withRouter(LinkedCampaignsCard))));



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesDashboard/components/linkedCampaigns/LinkedCampaignsCard.js